import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay , ModalFooter, ModalHeader } from "@chakra-ui/modal";
import { updateProfile } from "api/graphQL_users";
import Card from "components/card/custom";
import DivLoader from "components/divloader/DivLoader";
import InputField from "components/fields/InputField";
import React from "react";
import { toast } from "react-hot-toast";
import { MdHighlightOff } from "react-icons/md";

const EditProfileModal = ({
  data,
  fetchProfile,
}: {
  data: any;
  fetchProfile?: () => void;
}) => {
  const rootForm = {
    first_name: "",
    last_name: "",
    email: "",
    role: "ADMIN",
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [formValues, setFormValues] = React.useState<any>(rootForm);
  const [formValuesErr, setFormValuesErr] = React.useState<any>(rootForm);
  const [isCloseModal, setIsCloseModal] =  React.useState<boolean>(false);
  

  const handleClose = () => {
    setIsCloseModal(true)
    setFormValues(rootForm);
    setFormValuesErr(rootForm);
    setTimeout(() => {
      setIsCloseModal(false)
      onClose();
    }, 300);
  };

  function handleValueChange(e: any) { 

    const { id, value } = e.target;

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
       
    let isValid = true;
    let errorMessage = "";

    if (id === "email" && !emailRegex.test(value)) {
      isValid = false;
      errorMessage = "Invalid email address";
    }

    if (!isValid) {
      setFormValuesErr((prevErr: any) => ({
        ...prevErr,
        [id]: errorMessage,
      }));
      setFormValues((prevVal: any) => ({
        ...prevVal,
        [id]: value,
      }));
      return;
    } else {
      setFormValuesErr((prevErr: any) => ({
        ...prevErr,
        [id]: "",
      }));
      setFormValues((prevVal: any) => ({
        ...prevVal,
        [id]: value,
      }));
    }

    // setFormValues((preVal: any) => {
    //   return { ...preVal, [e.target.id]: e.target.value };
    // });
    // setFormValuesErr((preVal: any) => {
    //   return { ...preVal, [e.target.id]: "" };
    // });
  }

  function validateData() {

    let verifier: any;
    Object.keys(formValues).forEach((key: any) => {
      if (!(key === "password") && !formValues[key as keyof any]) {
        verifier = { ...verifier, [key]: "Please enter a value" };
      }
    });

    Object.entries(formValues).forEach(([key, value]) => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      
      if (key === "email" && value !== "" && !emailRegex.test(String(value || ""))) {
        verifier = {
          ...verifier,
          [key]: "Invalid email address",
        };
      }
    });
    // setFormValuesErr(verifier);
    setFormValuesErr(verifier);

    const hasEmptyValues = Object.values(formValues).some(
      (value) => value === ""
    );

    const hasErrors = Object.keys(verifier || {}).length > 0;
   
    if (hasErrors) {
      return false;
    }

    if (hasEmptyValues) {
      return false;
    }
    return true;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();
    let validate = validateData();
    if (validate) {
      try {
        setIsLoading(true); 
        const create = await updateProfile(formValues);
        console.log("create",create)
        if(create.errors) {
          toast.error(create.errors[0].message);
        } else {
          if(create.status == "success") {
            fetchProfile();
            handleClose();
            toast.success(create?.message ?? "User updated Successfully");
          } else {
            toast.error(create.message ?? "Something went wrong!");
          }
        }
        
        
      } catch (err: any) {
        if (err?.response?.status === 422) {
          toast.error("Please provide valid values");
        } else {
          toast.error(err?.response?.data?.message ?? "Unable save user data");
        }
      } finally {
        setIsLoading(false);
      }
    }
  }

  const initForm = () => {
    if (data) {
      setFormValues(() => {
        return {
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          role: data.role,
          password: data.password,
        };
      });
    }
  };

  return (
    <>
      <button
        onClick={() => {
          if (data) {
            initForm();
          }
          onOpen();
        }}
        className="w-fit rounded-xl border-2 border-indigo-200 bg-indigo-50 px-5 py-2 text-indigo-500 outline-none"
      >
        Change Details
      </button> 
      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        {/* <ModalContent className="!z-[1002] !m-auto !w-max min-w-[600px] !max-w-[85%] md:top-[12vh]"> */}
        <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
              isOpen && !isCloseModal ? "card-enter" : "card-exit"
            }`}>
          <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                        <MdHighlightOff
              className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
              onClick={handleClose}
            />
            Profile Information
          </ModalHeader>
          <ModalBody className="p-4">
            
              <div className="max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden px-[30px] scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-full scrollbar-w-1">
                <InputField
                  variant="auth"
                  extra="mt-3 w-full"
                  label="First Name*"
                  placeholder="Google inc."
                  id="first_name"
                  type="text"
                  value={formValues?.first_name}
                  errMessage={formValuesErr?.first_name ? formValuesErr?.first_name : ""}
                  onChange={handleValueChange}
                />
                <InputField
                  variant="auth"
                  extra="mt-3 w-full"
                  label="Last Name*"
                  placeholder="Google inc."
                  id="last_name"
                  type="text"
                  value={formValues?.last_name}
                  errMessage={formValuesErr?.last_name ? formValuesErr?.last_name : ""}
                  onChange={handleValueChange}
                />

                <InputField
                  variant="auth"
                  extra="mt-3 w-full"
                  label="Email*"
                  placeholder="user@lightningchecks.com"
                  id="email"
                  type="text"
                  value={formValues?.email}
                  errMessage={formValuesErr?.email ? formValuesErr?.email : ""}
                  onChange={handleValueChange}
                />
              </div>
              
           
          </ModalBody>
          <ModalFooter className="mt-[10px] p-4">
            <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                <button
                  onClick={handleClose}
                  className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                  // className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                >
                  Close
                </button>
                <button
                  onClick={handleSubmit}
                  className="linear rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white hover:text-white outline-none transition duration-200 hover:bg-indigo-600 active:bg-indigo-600 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                >
                  {isLoading ? (
                    <DivLoader className="h-6 w-6 border-white" />
                  ) : (
                    "Save Details"
                  )}
                </button>
              </div>
          </ModalFooter>
        </Card>
        {/* </ModalContent> */}
      </Modal>
    </>
  );
};
export default EditProfileModal;
